import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fundlender',
  templateUrl: './fundlender.component.html',
  styleUrls: ['./fundlender.component.css']
})
export class FundlenderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
